<template>
  <section class="notification-bar" :class="barDynamicClass">
    <Noti 
      v-if="noti && noti.base_type == 'system-sticky' && canShow && $route.name === 'Dashboard'"
      type="infor"
      variant="sticky"
      :isClose="true"
      :isInline="true"
      :actionTitle="actionTitle"
      :htmlDesc="notiDesc"
      @action="doAction"
      @onClose="dissmissMess"
    >
    </Noti>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import getLocale from "@/mixins/getLocale.js";
import checkGlobalConfigs from "@/mixins/checkGlobalConfigs";
import Noti from "@/core/shared/base/Notification"

export default {
  name: "NotiBar",
  components: {
    Noti
  },
  filters: {},
  mixins: [getLocale, checkGlobalConfigs()],
  props: {
    lastSysNoti: Array,
    hide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modelActive: true,
      alertCount: null,
      dismissed: true,
      display: 0
    };
  },
  computed: {
    ...mapGetters("notibar", {
      sticky: "sticky",
      last_system_noti: "last_system_noti",
      notiList: "noti"
    }),
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    actionTitle() {
      return this.$t("dashboard.notiBar.viewMore");
    },
    noti() {
      if (this.last_system_noti && this.last_system_noti[0]) {
        return this.last_system_noti[0];
      }
      return undefined;
    },
    notiDesc() {
      return this.getLocaleText(this.noti.desc);
    },
    isDevStore() {
      return this.shopInfo.developmentStore;
    },
    /**
     * check neu noti la read hoac unread ( <=1 thi show tren notibar), va neu loai noti la extend-trial va khong o trong ngay active nua thi khong show tren notibar
     * @returns {Boolean}
     */
    canShow() {
      if (this.noti?.settings?.data) {
        try {
          const settingsJSON = JSON.parse(this.noti.settings.data);

          if (Object.keys(settingsJSON).length == 0) {
            return true;
          }

          if (settingsJSON["free"] && this.isDevStore) {
            return true;
          }

          if (settingsJSON[this.shopInfo.plan]) {
            return true;
          }

          return false;
        } catch (err) {
          // eslint-disable-next-line no-console
          console.warn({
            err,
            json: this.noti.settings.data
          });
        }
      }
      const today = new Date();
      if (new Date(this.noti.to_date) < today || new Date(this.noti.from_date) > today) {
        return false;
      }
      // If the nay thi chiu khong doc hieu noi...
      return this.noti.state <= 1 && (!this.noti.settings["extend-trial"] || (this.noti.settings["extend-trial"] && new Date(this.noti.to_date) > today && new Date(this.noti.from_date) < today));
    },
    barDynamicClass() {
      return {
        hide: !(this.noti && this.canShow) || this.hide
      };
    }
  },
  watch: {
    // account: {
    //   deep: true,
    //   handler(newV) {
    //     console.warn(newV)
    //   }
    // }
  },
  created() {
    window.addEventListener("resize", this.onResize);
    if (window.innerWidth >= 1440) {
      this.display = 5;
    } else {
      this.display = 4;
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    ...mapActions("notibar", {
      dismissStickyNoti: "dismissStickyNoti",
      showModalNoti: "showModalNoti",
      trackAction: "trackAction",
      openNotiCenter: "showNotificationBar",
      openNotiContent: "openNotiContent"
    }),
    gotoPricing() {
      if (this.$route.name == "Pricing") return;
      this.$router.push({ name: "Pricing" });
    },
    dissmissMess() {
      this.dismissStickyNoti({
        onSuccess: () => {
          if (this.noti.is_important) {
            this.gSnackbarCommit({
              message: this.$t("generals.notiCenter.status.pinSuccessModal"),
              type: "success"
            });
          }
        }
      });
    },
    doAction() {
      if (["open_modal", "welcome_back"].includes(this.noti.action)) {
        this.showModalNoti(this.noti);
        this.trackAction(this.noti);
      } else if (this.noti.action == "open_url") {
        this.openNotiCenter();
        this.openNotiContent(this.noti);
        this.trackAction(this.noti);
      }
    },
    onResize() {
      if (window.innerWidth > 1024) {
        this.display = 5;
      } else {
        this.display = 4;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.notification-bar {
  position: sticky;
  top: 0;
  z-index: 48;
  // position: absolute;
  // left: 0;
  // top: 100%;
  // transform: translateX(50%);

  &.hide {
    position: relative;
  }

  .box-shadow {
    box-shadow: 0px 0.11069px 0.85785px rgba(0, 0, 0, 0.0112458), 0px 0.266004px 2.06153px rgba(0, 0, 0, 0.0161557), 0px 0.500862px 3.88168px rgba(0, 0, 0, 0.02), 0px 0.893452px 6.92426px rgba(0, 0, 0, 0.0238443), 0px 1.6711px 12.9511px rgba(0, 0, 0, 0.0287542), 0px 4px 31px rgba(0, 0, 0, 0.04);
  }
  .neutral {
    height: 32px;
    border-left: 2px solid $accentRed;
    padding-left: 14px;
    padding-right: 16px;
    background: $light1;
    align-items: center;
    .content {
      color: $textLightModeHigh;
      max-width: 80%;
      span {
        margin-left: 8px;
        margin-right: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    > i {
      font-size: 12px;
      cursor: pointer;
      padding: 4px;
      border-radius: $radius;
      @include trans-all;
      &:hover {
        background: $light2;
      }
    }
    .view-more {
      // margin-left: auto;
      button {
        cursor: pointer;
        border-radius: $radius;
        padding: 4px 33px;
        background: #fff;
        color: $textLightModeHigh;
        border: 1px solid #333333;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        &:not(:disabled):not(.disabled):hover {
          background-color: $textDarkModeHigh;
        }
      }
      span {
        color: $mono3;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:hover {
          color: $mono5;
        }
      }
    }
  }

  .call-to-action {
    height: 32px;
    border-left: 2px solid $mono3;
    padding-left: 14px;
    padding-right: 16px;
    background: $light1;
    align-items: center;
    .content {
      color: $textLightModeHigh;
      margin-right: 8px;
      max-width: 80%;
      span {
        margin-left: 8px;
        margin-right: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      span {
        margin-left: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    > i {
      font-size: 12px;
      cursor: pointer;
      padding: 4px;
      border-radius: $radius;
      @include trans-all;
      &:hover {
        background: $light2;
      }
    }
    .view-more {
      padding-top: 2px;
      padding-bottom: 2px;
    }
  }
}
</style>
